var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {notification: true}, _obj[_vm.typeClass] = true, _obj )},[_c('span',{staticClass:"notification-icon"},[(_vm.type === 'success')?_c('CheckIcon'):(_vm.type === 'error')?_c('XCircleIcon'):_vm._e()],1),_c('span',{staticClass:"notification-message"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }